import { isAfter, addHours } from 'date-fns'

import { GTTripItineraryStop, GTTripV2, GTTripV2Status } from 'gql/types.generated'
import { ISegmentOnEditTrip } from 'models/trips/types'
import { getHourMinuteByTimeAndDay } from 'utils/date'

const CREATE_INCIDENCE_COUPONS_ACCEPTED_INTERVAL_HOURS =
  (process.env.CREATE_INCIDENCE_COUPONS_ACCEPTED_INTERVAL_HOURS &&
    parseInt(process.env.CREATE_INCIDENCE_COUPONS_ACCEPTED_INTERVAL_HOURS)) ||
  48

export const isCreateIncidenceCouponsEnabled = (trip: GTTripV2): boolean => {
  const now = new Date()

  switch (trip.status) {
    case GTTripV2Status.InTransit:
      return true
    case GTTripV2Status.Completed:
      return isAfter(addHours(new Date(trip.arrivalAt), CREATE_INCIDENCE_COUPONS_ACCEPTED_INTERVAL_HOURS), now)
    default:
      return false
  }
}

export const getTripSegmentsSummaryOnEditTrip = (
  oldItinerary: GTTripItineraryStop[],
  newItinerary: GTTripItineraryStop[]
): ISegmentOnEditTrip[] => {
  const newSegments: ISegmentOnEditTrip[] = []
  const oldSegments: ISegmentOnEditTrip[] = []
  newItinerary.forEach((stop, stopIndex) => {
    const isDestination = stopIndex === newItinerary.length - 1

    if (isDestination) return

    const nextStop = newItinerary[stopIndex + 1]

    newSegments.push({
      origin: stop,
      destination: nextStop,
      isAdded: false,
      isRemoved: false,
      hasNewDeparture: false,
      hasNewArrival: false
    })
  })

  oldItinerary.forEach((stop, stopIndex) => {
    const isDestination = stopIndex === oldItinerary.length - 1

    if (isDestination) return

    const nextStop = oldItinerary[stopIndex + 1]

    oldSegments.push({
      origin: stop,
      destination: nextStop,
      isAdded: false,
      isRemoved: false,
      hasNewDeparture: false,
      hasNewArrival: false
    })
  })

  newSegments.map((newSegment) => {
    const oldSegment = oldSegments.find(
      (oldSegment) =>
        oldSegment.origin.place.id === newSegment.origin.place.id &&
        oldSegment.destination.place.id === newSegment.destination.place.id
    )

    if (oldSegment) {
      newSegment.hasNewDeparture = !(
        oldSegment.origin.departure?.time === newSegment.origin.departure?.time &&
        oldSegment.origin.departure?.day === newSegment.origin.departure?.day
      )
      newSegment.hasNewArrival = !(
        oldSegment.destination.arrival?.time === newSegment.destination.arrival?.time &&
        oldSegment.destination.arrival?.day === newSegment.destination.arrival?.day
      )
    } else {
      newSegment.isAdded = true
    }

    return newSegment
  })

  oldSegments.map((oldSegment) => {
    const newSegment = newSegments.find(
      (newSegment) =>
        oldSegment.origin.place.id === newSegment.origin.place.id &&
        oldSegment.destination.place.id === newSegment.destination.place.id
    )

    if (!newSegment) {
      oldSegment.isRemoved = true
    }

    return oldSegment
  })

  const removedSegments = oldSegments.filter(({ isRemoved }) => isRemoved)
  const segments = [...removedSegments, ...newSegments]
  segments.sort((a, b) => {
    const [aHour, aMinute] = getHourMinuteByTimeAndDay(
      a.origin.departure?.time ?? '00: 00',
      a.origin.departure?.day ?? 0
    )
    const aTime = aHour * 60 + aMinute
    const [bHour, bMinute] = getHourMinuteByTimeAndDay(
      b.origin.departure?.time ?? '00:00',
      b.origin.departure?.day ?? 0
    )
    const bTime = bHour * 60 + bMinute
    if (!a.isRemoved && !b.isRemoved) {
      return 0
    }
    if (bTime > aTime) {
      return -1
    } else if (aTime > bTime) {
      return 1
    }
    return 0
  })

  return segments
}
